(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["payment-avaibility"] && !Shopify.designMode) return;
  try {
    (function () {
  const WIDGET_SEL = '#alma-widget';

  function findAlma() {
    const root = document.querySelector(WIDGET_SEL);
    if (!root) return null;
    const listbox =
      root.querySelector('[role="listbox"]') ||
      root.querySelector('.alma-payment-plans-eligibility-options');
    if (!listbox) return null;
    const options = Array.from(listbox.querySelectorAll('[role="option"], button'));
    return options.length ? { root, options } : null;
  }

  function getPlanBtn(alma, n) {
    const labelled = alma.root.querySelector('[aria-label="Option de paiement ' + n + 'x"]');
    if (labelled) return labelled;
    return alma.options.find(o => (o.textContent || '').trim().toLowerCase() === n + 'x') || null;
  }

  function planEnabled(alma, n) {
    const b = getPlanBtn(alma, n);
    return !!b && b.getAttribute('aria-disabled') !== 'true';
  }

  document.querySelectorAll('[data-alma-pay]').forEach(function (block) {
    const link = block.querySelector('[data-alma-open]');
    const amountEl = block.querySelector('[data-alma-amount]');
    const root = block.closest('.product__info') || document;
    const currency = block.getAttribute('data-currency') || 'EUR';
    const minAmount = parseFloat(block.getAttribute('data-min-amount')) || 0;

    let formatter = null;
    try {
      formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency });
    } catch (e) {
      formatter = null;
    }

    function priceEl() {
      return (
        root.querySelector('[data-product-price-list] .price--large') ||
        document.querySelector('[data-product-price-list] .price--large')
      );
    }

    function readPrice(el) {
      const clone = el.cloneNode(true);
      clone.querySelectorAll('.visually-hidden').forEach(n => n.remove());
      const txt = (clone.textContent || '').replace(/ /g, ' ');
      const num = txt.replace(/[^0-9.,]/g, '').replace(/\s/g, '').replace(',', '.');
      const val = parseFloat(num);
      return isNaN(val) ? null : val;
    }

    function currentTotal() {
      const el = priceEl();
      return el ? readPrice(el) : null;
    }

    function syncAmount(total) {
      if (total == null || !formatter) return;
      amountEl.textContent = formatter.format(total / 4);
    }

    function refresh() {
      const total = currentTotal();
      const eligible = total != null && total >= minAmount;
      block.hidden = !eligible;
      if (eligible) syncAmount(total);
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      const alma = findAlma();
      if (!alma) return;
      const btn = getPlanBtn(alma, 4);
      if (btn && btn.getAttribute('aria-disabled') !== 'true') btn.click();
    });

    refresh();

    const priceNode = priceEl();
    if (priceNode) {
      const pmo = new MutationObserver(function () { refresh(); });
      pmo.observe(priceNode, { childList: true, subtree: true, characterData: true });
    }

    ['variant:changed', 'variant:change', 'product:variant-change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(refresh, 60); }, { passive: true });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["retractation-order-button"] && !Shopify.designMode) return;
  try {
    (function () {
    var FIELD_LABELS = {
      firstname: 'Prénom',
      name: 'Nom',
      email: 'Adresse email',
      order: 'Numéro de commande',
      products: 'Produit(s) concerné(s)'
    };

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function setupRoot(root) {
      var ui = root.querySelector('[data-retractation-ui]');
      var startBtn = root.querySelector('[data-retractation-start]');
      var confirmBox = root.querySelector('[data-retractation-confirm]');
      var confirmBtn = root.querySelector('[data-retractation-confirm-btn]');
      var cancelBtn = root.querySelector('[data-retractation-cancel]');
      var errorEl = root.querySelector('[data-retractation-error]');
      var receipt = root.querySelector('[data-retractation-receipt]');

      if (!ui || !startBtn || !confirmBox || !confirmBtn || !cancelBtn) return;

      function collect() {
        return {
          orderId: root.getAttribute('data-order-id') || '',
          orderNumber: root.getAttribute('data-order-number') || '',
          email: root.getAttribute('data-email') || '',
          firstName: root.getAttribute('data-firstname') || '',
          lastName: root.getAttribute('data-lastname') || '',
          products: root.getAttribute('data-products') || ''
        };
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function fillReceipt(d) {
        var listEl = receipt.querySelector('[data-receipt-summary-list]');
        var summaryWrap = receipt.querySelector('[data-receipt-summary]');
        var rows = [
          ['firstname', d.firstName],
          ['name', d.lastName],
          ['email', d.email],
          ['order', d.orderNumber],
          ['products', d.products]
        ];
        if (listEl) {
          listEl.innerHTML = '';
          rows.forEach(function (r) {
            if (!r[1]) return;
            var row = document.createElement('div');
            var dt = document.createElement('dt');
            var dd = document.createElement('dd');
            dt.textContent = FIELD_LABELS[r[0]];
            dd.textContent = r[1];
            row.appendChild(dt);
            row.appendChild(dd);
            listEl.appendChild(row);
          });
        }
        if (summaryWrap) summaryWrap.hidden = false;

        var now = new Date();
        var dateStr = pad(now.getDate()) + '/' + pad(now.getMonth() + 1) + '/' + now.getFullYear();
        var timeStr = pad(now.getHours()) + ':' + pad(now.getMinutes());
        var dEl = receipt.querySelector('[data-receipt-date]');
        if (dEl) dEl.textContent = dateStr;
        var tEl = receipt.querySelector('[data-receipt-time]');
        if (tEl) tEl.textContent = timeStr;

        var printBtn = receipt.querySelector('[data-receipt-print]');
        if (printBtn) {
          printBtn.addEventListener('click', function () { window.print(); }, { once: true });
        }
      }

      startBtn.addEventListener('click', function () {
        if (errorEl) errorEl.hidden = true;
        startBtn.hidden = true;
        confirmBox.hidden = false;
      });

      cancelBtn.addEventListener('click', function () {
        confirmBox.hidden = true;
        startBtn.hidden = false;
      });

      confirmBtn.addEventListener('click', function () {
        var d = collect();
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Envoi…';

        fetch(root.getAttribute('data-endpoint'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(d)
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (json) {
              if (!res.ok || !json.ok) {
                throw new Error((json && json.error) || 'Une erreur est survenue. Réessayez.');
              }
              return json;
            });
          })
          .then(function () {
            if (!receipt) {
              showError('Erreur interne : accusé introuvable.');
              confirmBtn.disabled = false;
              confirmBtn.textContent = 'Confirmer';
              return;
            }
            ui.hidden = true;
            fillReceipt(d);
            receipt.hidden = false;
            receipt.scrollIntoView({ behavior: 'smooth', block: 'start' });
          })
          .catch(function (err) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Confirmer';
            confirmBox.hidden = true;
            startBtn.hidden = false;
            showError(err.message || 'Une erreur est survenue. Réessayez.');
          });
      });
    }

    function init() {
      var roots = document.querySelectorAll('[data-retractation-order]');
      for (var i = 0; i < roots.length; i++) {
        setupRoot(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
